import React, { useState } from 'react';
import { Code } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export default function HtmlImportButton({ onOpen }) {
  const { t, isDark } = useTheme();
  const [hovered, setHovered] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={onOpen}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          backgroundColor: hovered ? (isDark ? 'rgba(245,230,200,0.06)' : 'rgba(61,36,18,0.04)') : 'transparent',
          border: 'none', borderRadius: '6px',
          color: hovered ? t.text : t.textSecondary,
          cursor: 'pointer', transition: 'all 0.15s ease',
        }}
      >
        <Code size={18} />
      </button>
      {hovered && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)',
          padding: '4px 8px', backgroundColor: t.modalBg, border: `1px solid ${t.borderStrong}`,
          borderRadius: '4px', fontSize: '11px', fontFamily: 'Poppins, sans-serif',
          color: t.textSecondary, whiteSpace: 'nowrap', pointerEvents: 'none', zIndex: 10,
        }}>Import HTML</div>
      )}
    </div>
  );
}
